const content = {
    creditScoreHeader: "credit.creditScore.creditScoreWidget.message",
    dailyCreditScoreHeader: "TransUnion Daily Credit Score",
    creditSimulatorHeader:
        "The credit score simulator estimates how your credit score might change based on potential financial actions below. Using the simulator does not affect your actual credit score, so you can experiment with different actions to see the impact.",
   
    whatYouNeedToKnowTitle: "credit.creditScore.creditScoreWidget.whatYouNeedToKnowTitle",
    whatYouNeedToKnowDescription:
        "credit.creditScore.creditScoreWidget.whatYouNeedToKnowContent",
       
};

const defaultRetailer='RETAILER-DFLT';
export { content,defaultRetailer };
